import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Button,
  Badge,
} from 'reactstrap';

import {
  Field,
} from 'redux-form';

import TextBox from '../../../../shared/components/form/TextBox';
import renderSelectField from '../../../../shared/components/form/Select';

const ProyectoTrabajoPracticoTable = ({
  materiaPeriodo,
  fields = {},
  meta: { error, submitFailed },
  onDeleteItemArray,
  onChangeText,
  onChangeSelect,
  items,
  profesores,
  duracionActividad,
}) => {
  const isNew = items.some(o => !o.deleted && o.id === 0);
  return (
    <div className="form__form-group-field" style={{ flexDirection: 'column' }}>
      <div>
        <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
          {fields.map((objetivo, index) => {
            if (!items[index]) {
              return null;
            }

            return (
              <div
                key={`${objetivo}`}
                id={`${objetivo}`}
                style={{ borderRadius: '10px', padding: '0' }}
                className={(items[index].deleted || (items[index].id > 0 && isNew)) ? 'hidden' : ''}
              >
                <div style={{ borderTop: '0' }}>
                  <Row
                    className="wizard__subform"
                    style={{
                      borderRadius: '10px', borderTop: '0', marginRight: '0', marginLeft: '0',
                    }}
                  >
                    <Col md={12}>
                      <div style={{
                        display: 'flex',
                        gap: '1rem',
                        justifyItems: 'center',
                        justifyContent: 'flex-start',
                        alignItems: 'baseline',
                        marginBottom: '1rem',
                        padding: '0.4rem',
                        backgroundColor: '#38373f',
                      }}
                      >
                        <h3><Badge color="primary">#{index + 1}</Badge></h3>
                        {
                          materiaPeriodo.canEditarPlaneamiento ? (
                            <Button
                              key={`btn-remove-${objetivo}`}
                              onClick={() => onDeleteItemArray({ name: fields.name, index })}
                              size="sm"
                              outline
                              color="danger"
                              style={{ marginBottom: '0px' }}
                              className="font-weight-bold"
                            >
                              <i className="fa fa-trash" aria-hidden="true" />
                            </Button>
                          ) : null
                        }
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <Row>

                        <Col md={12}>
                          <div className="form__form-group">
                            <span className="form__form-group-label required">Profesor</span>
                            <div className="form__form-group-field">
                              <Field
                                name={`${objetivo}.profesorMateria`}
                                placeholder="Profesor"
                                onChange={props => onChangeSelect({
                                  option: props,
                                  name: fields.name,
                                  target: { name: `${objetivo}.profesorMateria` },
                                  index,
                                })}
                                options={profesores}
                                component={renderSelectField}
                                isDisabled={!materiaPeriodo.canEditarPlaneamiento}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col lg={6} md={6}>
                          <div className="form__form-group">
                            <span className="form__form-group-label required">Duraci&oacute;n</span>
                            <div className="form__form-group-field">
                              <Field
                                name={`${objetivo}.duracion`}
                                placeholder="Duraci&oacute;n"
                                onChange={props => onChangeSelect({
                                  option: props, name: fields.name, target: { name: `${objetivo}.duracion` }, index,
                                })}
                                options={duracionActividad}
                                component={renderSelectField}
                                isDisabled={!materiaPeriodo.canEditarPlaneamiento}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Actividad</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.actividad`}
                            placeholder="Actividad"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            style={{ minHeight: '10rem' }}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Descripci&oacute;n</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.descripcion`}
                            placeholder="Descripci&oacute;n"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            style={{ minHeight: '10rem' }}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Evaluaci&oacute;n</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.evaluacion`}
                            placeholder="Evaluaci&oacute;n"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            style={{ minHeight: '10rem' }}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>

                  </Row>
                </div>
              </div>
            );
          })}
        </div>
        {
          submitFailed && error && (
            <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
              {error}
            </span>
          )
        }
      </div>
    </div>
  );
};

ProyectoTrabajoPracticoTable.propTypes = {
  onDeleteItemArray: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  profesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  duracionActividad: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  materiaPeriodo: PropTypes.shape({}).isRequired,
};

ProyectoTrabajoPracticoTable.defaultProps = {
  meta: {},
};

export default ProyectoTrabajoPracticoTable;
